import { render } from "./systemParametersManagement.vue?vue&type=template&id=4f103785"
import script from "./systemParametersManagement.vue?vue&type=script&lang=js"
export * from "./systemParametersManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__